import * as React from "react";

const TechTreeButton =  (props) => {

    let TANK_KIND_CLASS = "tank-tree_box js-tech-tree_box";
    if (vehicle.info.tags.includes("retiredTank")) {
        TANK_KIND_CLASS += " retired-tank";
    } else if(vehicle.info.is_premium) {
        TANK_KIND_CLASS += " premium-tank"
    }

    return (
        <a className={TANK_KIND_CLASS} data-value={props.value} data-mapping={props.mapping} href={props.tankUrl}>
            <div className="tank-tree_tank-img">
                <img src={props.img} onError={(e) => {e.target.style.display = "none"}}/>
            </div>
            <div className="tank-tree_name">{props.name}</div>
            <div className="tank-tree_level">{props.level}</div>
            <div className="tank-tree_type">
                <span className="svg-icon js-svg-icon"
                      data-src={ STATIC_URL + "portal/img/svg-icons/vehicle-types/" + props.type + ".svg"}>
                </span>
            </div>
            <div className="tank-tree_holder">
                <div className="tank-tree_price">
                    <span className="svg-icon js-svg-icon"
                          data-src={ STATIC_URL + "portal/img/svg-icons/currency/silver.svg"}>
                    </span>
                    <span>{props.price.toLocaleString() }</span>
                </div>
                <div className="tank-tree_exp">
                    <span className="svg-icon js-svg-icon"
                          data-src={STATIC_URL + "portal/img/svg-icons/currency/exp.svg"}>
                    </span>
                    <span>{props.exp.toLocaleString()}</span>
                </div>
            </div>
        </a>
    )
};

export default TechTreeButton;
